import type { RichWhisperComponentMap } from '@frontend/react-domain';
import { CalendarEventWhisper } from './Whisper/CalendarEventWhisper';
import { VendorContactWhisper } from './Whisper/VendorContactWhisper';
import { withWhisperAccordion } from './Whisper/withWhisperAccordion';

export const WEB_WHISPER_COMPONENTS: RichWhisperComponentMap = {
  calendar_event: withWhisperAccordion(CalendarEventWhisper),
  vendor_contact: VendorContactWhisper,
};
